module.exports = __webpack_public_path__ + "img/bg-chat-tile-light.af1cec05.png";